import {Directive, EventEmitter, HostListener, Output} from "@angular/core";

@Directive({
    selector: '[ngModel][kanUppercase]'
})
export class kanUppercase {
    private value: any;
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

    @HostListener('blur', ['$event']) onInputBlur($event) {
        this.value = $event.target.value.toUpperCase();
        this.ngModelChange.emit(this.value);
    }
}



// WEBPACK FOOTER //
// ./src/modules/common/directives/uppercase.ts